import React, { useContext, useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Cookies from "js-cookie";

import Purple_border_btn from "../../../common_components/common_btn/purple_border_btn/Purple_border_btn";
import Purple_Btn from "../../../common_components/common_btn/purple_btn/Purple_Btn";
import Uploaded_img_holder from "../../../common_components/uploaded_img_holder/Uploaded_img_holder";
import { getBespokeProgress, postBespokeStep3 } from "../../../../utils/apis/BespokeGift/bespoke_gift";
import { Context } from "../../../../utils/context";

function Step_3({ handleNext, handleBack }) {
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [uploadedImages, setUploadedImages] = useState([]);

  const { IMG_URL } = useContext(Context)

  const {
    register,
    handleSubmit,
    control, setValue,
    reset, watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      recipient_name: "",
      custom_text: "",
      font_style: "",
    },
  });

  useEffect(() => {
    const draftId = Cookies.get("draftId");
    if (!draftId) return;

    const fetchDraft = async () => {
      try {
        const res = await getBespokeProgress(draftId);
        if (res?.success) {
          const data = res.data;

          reset({
            ...data,
            recipient_name: data?.recipient_name || "",
            custom_text: data?.custom_text || "",
            font_style: data?.font_style || "",
          });

          if (data?.bespoke_order_logos?.length > 0) {
            setValue("images",
              data?.bespoke_order_logos?.map((item) => IMG_URL + item?.image) || []
            );
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDraft();
  }, []);

  const imageFiles = watch("images");

  const onSubmit = async (data) => {
    setLoading(true);
    setApiError(null);

    try {
      const formData = new FormData();
      formData.append("draft_id", Cookies.get("draftId") || "");
      formData.append("recipient_name", data.recipient_name);
      formData.append("custom_text", data.custom_text || "");
      formData.append("font_style", data.font_style || "");


      if (uploadedImages && uploadedImages.length > 0) {
        for (let i = 0; i < uploadedImages.length; i++) {
          formData.append("logo", uploadedImages[i].file);
        }
      }

      const res = await postBespokeStep3(data?.id, formData);

      if (res?.success) {
        Cookies.set("draftId", res?.data?.draftId, { expires: 1 });
        handleNext({ draftId: res?.data?.draftId, step3: data });
      } else {
        setApiError(res?.message || "Failed to save. Please try again.");
      }
    } catch (err) {
      setApiError(err?.message || "Failed to save. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="step_form_content">
        <Form>
          <Row className="gy-4">

            <Col md={12}>
              <Form.Group className="form_group">
                <Form.Label>Recipient Name(S)*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Name"
                  isInvalid={!!errors.recipient_name}
                  {...register("recipient_name", {
                    // required: "Recipient name is required",
                    minLength: { value: 2, message: "Min 2 characters" },
                    maxLength: { value: 200, message: "Max 200 characters" },
                  })}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.recipient_name?.message}
                </Form.Control.Feedback>
                <p className="form_hint">e.g., For printing or engraving</p>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="form_group">
                <Form.Label>Upload Your Artwork / Design*</Form.Label>
                <Uploaded_img_holder
                  imageFiles={imageFiles}
                  setUploadedImages={setUploadedImages}
                  uploadedImages={uploadedImages}
                />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="form_group">
                {/* <Form.Label>Custom Text / Quote</Form.Label> */}
                <Form.Label>Specify Dimensions, Size, and Material</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Specify Dimensions, Size, and Material"
                  isInvalid={!!errors.custom_text}
                  {...register("custom_text", {
                    required: "Specify Dimensions, Size, and Material is Required",
                    maxLength: { value: 200, message: "Max 200 characters" },
                  })}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.custom_text?.message}
                </Form.Control.Feedback>
                <p className="form_hint">e.g., "with love, from team xyz"</p>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="form_group">
                {/* <Form.Label>Font Style / Engraving Type</Form.Label> */}
                <Form.Label>Add Your Custom Text / Quote</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Add Your Custom Text / Quote"
                  isInvalid={!!errors.font_style}
                  {...register("font_style", {
                    maxLength: { value: 100, message: "Max 100 characters" },
                  })}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.font_style?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

          </Row>

          {apiError && (
            <div className="alert alert-danger mt-3 py-2" role="alert">
              {apiError}
            </div>
          )}
        </Form>
      </section>

      <div className="btn_holder">
        <Purple_border_btn onClick={handleBack} btnText="Back" />
        <Purple_Btn
          onClick={handleSubmit(onSubmit)}
          btnText={loading ? "Saving..." : "Save & Next"}
          disabled={loading}
        />
      </div>
    </>
  );
}

export default Step_3;